import { useMemo } from 'react';
import { useLocation } from 'react-router';

const useSearchParam = (key: string) => {
  const { search } = useLocation();
  return useMemo(() => {
    const params = new URLSearchParams(search);
    return params.get(key);
  }, [search, key]);
};

export default useSearchParam;
